import { Component, OnDestroy, OnInit } from "@angular/core";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import { Store } from "@ngxs/store";
import { IntakeService } from "app/intake/intake-services/intake.service";
import { CommonService } from "app/reusable/common.service";
import { ResetState, SetDossier } from "app/_actions/intake.actions";
import { ROLES } from "app/_constants/roles";
import { AuthenticationService } from "app/_services";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CalamityService } from "../calamity.service";
import {SharedService} from '../../_services/shared.service';
import { CedNotificationService } from "ced-ng-library";
import { environment } from "environments/environment";

@Component({
  selector: "app-calamity-dossier-list",
  templateUrl: "./calamity-dossier-list.component.html",
  styleUrls: ["./calamity-dossier-list.component.scss"],
})
export class CalamityDossierListComponent implements OnInit, OnDestroy {
  private _subject$: Subject<boolean> = new Subject();
  calamityId: string;
  dataSource = [];
  selectedDossier;
  editMode: boolean = false;
  public serverUrlSlot1 : string = environment.Services.AlphaURLSlot1;
  public serverUrlSlot2 : string = environment.Services.AlphaURLSlot2;
  faFolderOpen = faFolderOpen;
  public hasIntakeCreationPermission: boolean=true;

  constructor(
    private sharedService: SharedService,
    private calamityService: CalamityService,
    private commonService: CommonService,
    private intakeService: IntakeService,
    private store: Store,
    private authenticationService: AuthenticationService,
    private cedNotificationService: CedNotificationService,

  ) {}

  ngOnInit() {
    this.getRoles();
    this.hasIntakeCreationPermission = this.sharedService.checkPermissionByRole("Intake").hasCreate;
    this.getCalamityId();
    this.getDossierByCalamityId();
  }

  getRoles() {
    let roles = this.authenticationService.getLocalStorageRoles();
    if (roles != null) {
      this.editMode =
        roles.find(
          (r) =>
            r.authorizationRoleId.trim() == ROLES.DOSSIER_MANAGEMENT &&
            r.operationUpdate == true
        ) != undefined;
    }
  }

  getCalamityId() {
    this.calamityService.calId$
      .pipe(takeUntil(this._subject$))
      .subscribe((res) => {
        this.calamityId = res;
      },
      (error) => {
          this.cedNotificationService.error("NOTIFICATIONS.GET_CALAMITY_BY_ID");
      });
  }

  getDossierByCalamityId() {
    if (this.calamityId != null) {
      let GetDossierUrl: string =
        `Dossier/GetDossiersByCalamityId/` + this.calamityId;
      this.commonService
        .getData(GetDossierUrl, this.serverUrlSlot1)
        .pipe(takeUntil(this._subject$))
        .subscribe((data: any) => {
          this.dataSource = data;
          this.dataSource.forEach((element) => {
            element.creationDate = this.getLocaleDate(element.creationDate);
            element.lastModificationDate = this.getLocaleDate(
              element.lastModificationDate
            );
          });
        },
        (error) => {
            this.cedNotificationService.error("NOTIFICATIONS.GET_DOSSIER");
        });
    }
  }

  getLocaleDate(date: Date) {
    return this.intakeService.getLocalDate(date);
  }

  getDossierById(dossierId, editMode) {
    let GetDossierUrl: string = `Dossier/GetById/` + dossierId;
    this.commonService
      .getData(GetDossierUrl, this.serverUrlSlot2)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        this.store.dispatch(new SetDossier(data, editMode));
      },
      (error) => {
          this.cedNotificationService.error("NOTIFICATIONS.GET_DOSSIER");
      });
  }

  dblClickEvent() {
    if (this.selectedDossier != null)
      this.getDossierById(this.selectedDossier.dossierId, this.editMode);
    this.selectedDossier = null;
  }

  onCellClick($event) {
    this.selectedDossier = $event.dataItem;
  }

  startNewIntake() {
    this.store
      .dispatch(new ResetState())
      .pipe(takeUntil(this._subject$))
      .subscribe((res) => {});
  }

  ngOnDestroy(): void {
    this._subject$.unsubscribe();
  }
}
